// extracted by mini-css-extract-plugin
module.exports = {"regionFlag":"index_regionFlag__leRyl","flagWarp":"index_flagWarp__ZY_SI","flag":"index_flag__ulsBs"};